import axios from '../axiosConfig'; // Assuming this is your configured Axios instance 
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;
console.log('Axios BaseURL', baseURL); 
const fetchProfileContent = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/profile', {
      headers: headers
    }); 
 debugger
    return response;
  } catch (error) {
    console.error('Error fetching protected content:', error);
    return null; 
  }
};

const postProfileContent = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/profile/settings', data, {
        headers: headers
      }); 
      return response;
    } catch (error) { 
      return error;
    }
  };
  
const fetchLoginHistory = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/login/history', {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
};

const forgetPassword = async (data) => {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

  try {
    const response = await axios.post('/forgotpassword', data, { headers });
    console.log('Response:', response);
    console.log('Response code:', response.code);
    console.log('Response status:', response.status);
    if (response.status) {
      return response;
    }
    else{
        // Handle specific HTTP errors here if necessary
        console.log('Client error:', response.data);
        return response.data;
    }
  } catch (err) {
    console.error('Error in forgetPassword:', err);
      // Extract status and error message
      const status = err.response?.status || 500; // Default to 500 if no status is available
      console.log(err.response);
      const errorMessage =
        err.response?.data?.message || // Error message from the backend
        (status === 400
          ? 'Bad Request: Invalid input'
          : status === 401
          ? 'Unauthorized: Please log in'
          : status === 500
          ? 'Server Error: Please try again later'
          : 'An unknown error occurred'); // Fallback message
  
      // Standardize error response
      return {
        success: false,
        status, // Include HTTP status code
        message: errorMessage, // Provide a detailed error message
      };
  }
};


const verificationCode = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};

  try {
    const response = await axios.post('/verificationcode', data, {
      headers: headers
    });
    console.log(response);
    return response.data;
  } catch (error) {
    console.error('Error vevrificationCode content:', error);
    return {
      success: false,
      message: "Error from response", // Provide a detailed error message
    };
  }
};


const changePassword = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;

  try {
    const response = await axios.post('/changepassword', data, {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
};
const ProfilechangePassword = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;

  try {
    const response = await axios.post('/profile/changepassword', data, {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
};

const registerUser = async (data) => {
  console.log('registration data', data);

  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  // if (! axios.defaults.headers.common["Authorization"]){
  //   headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  // }

  try {
    const response = await axios.post('/register', data, {
      headers: headers
    });
    console.log('response from backend', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching protected content:', error);
  }
};

const apiError = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post('/register', data, {
      headers: headers
    });
    // console.log(response);
    return response.profile;
  } catch (error) {
    console.error('Error register content:', error);
  }
};
const resetRegisterFlag = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post('/register', data, {
      headers: headers
    });
    // console.log(response);
    return response;       
  } catch (error) {
    console.error('Error register content:', error);
  }
};


const getUserList = async (page, size, searchTerm = null) => { 
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try { 
    let url = `/list_users?page=${page}&per_page=${size}`;
    
    // Add search parameter if provided
    if (searchTerm && searchTerm.trim()) {
      url += `&ilike=${encodeURIComponent(searchTerm.trim())}`;
    }
    
    console.log('Users API URL:', url);
    console.log('Search term:', searchTerm);
    
    const response = await axios.get(url, {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    return error;
  }
};
const addUser = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post('/adduser', data,{
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
}
const getUserDetails = async (id) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get(`/user/${id}`, {
      headers: headers
    });  
    return response;
  } 
  catch (error) {
    return error; 
  }
}
const updateUser = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  try {
    const response = await axios.put(`/modify_user/${data.id}`, data, {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
}

const deleteUser= async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  try {
    const response = await axios.delete(`/remove_user/${data}`, {
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    return error;
  }
}

const addCheckin= async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'}; 
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`; 
  }
  try { 
    const response = await axios.post('/office/attendance/checkin', {},{
      headers: headers
    });
    // console.log(response);
    return response; 
  }
  catch (error) {
    return error; 
  }
}
const addCheckout= async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'}; 
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`; 
  }
  try {
      
    const response = await axios.post('/office/attendance/checkout', {}, {
      headers: headers
    });
    // console.log(response);
    return response; 
  }
  catch (error) {
    return error; 
  }
}

const getCheckInData = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
      
    const response = await axios.get('/office/attendance', {
      headers: headers
    });  
    return response;
  } 
  catch (error) {
    return error; 
  }
}

const fetchAvatarList = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/file/avatar/list', {
      headers: headers
    });
    console.log(response);
    return response;  
  } 
  catch (error) {
    return error;
  }
}

const selectAvatar = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  } 
  try {
    const response = await axios.post('/select-avatar', data, {
      headers: headers
    });
    console.log(response);
    return response; 
  }
  catch (error) {
    return error; 
  }
}
export { fetchProfileContent, postProfileContent,verificationCode,forgetPassword,changePassword,registerUser,apiError,resetRegisterFlag,fetchLoginHistory, baseURL,ProfilechangePassword,getUserList,updateUser,addUser,deleteUser,getUserDetails,addCheckin,addCheckout,getCheckInData,fetchAvatarList,selectAvatar };
 